<template>
    <div id="RentalContractInvoiceView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar"> <!--right sidebar-->
            <div class="right-asset-tab-list purchase-order-right-tab">
                <div id="tabs" class="containerTab">
                    <div class="tabs">
                        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Fuel Ticket Details</a>
                        <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
                    </div>
                    <div class="content">
                        <div v-show="activetab === 1" class="tabcontent">
                            <div class="list-view">
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Invoice Type:</label>
                                    <span class="col">{{invType}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Invoice #:</label>
                                    <span class="col">{{invoice_number}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Invoice Date :</label>
                                    <span class="col">{{invoice_date}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Due Date :</label>
                                    <span class="col">{{dueDate}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Customer :</label>
                                    <span class="col">{{customer}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Status :</label>
                                    <span class="col">{{status}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Term :</label>
                                    <span class="col">{{term}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Created Date :</label>
                                    <span class="col">{{created_at}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Open Amount :</label>
                                    <span class="col">{{open_amount}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Total Amount :</label>
                                    <span class="col">{{total_amount}}</span>
                                </div>
                            </div>
                        </div>
                        <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                            <invoice-activity-log-list :activityLogVal="activityLogsTabValue"></invoice-activity-log-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area purchase-order-left-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name purchase-order-title">
                    <div class="page-title"> # {{invoice_number}}</div>
                    <div class="btn-groups text-right">
                        <button type="button" v-if="canAddCrm && deleted_at == null" class="btn btn-secondary" v-on:click="crmSection()" >
                            <i class="fp-agreement"> </i> {{crmBtnTitle}}
                        </button>
                        <template v-if="!isCrmSection">
                        <button v-if="deleted_at == null" type="submit" id="previewInvoiceBtn" v-on:click="previewInvoice()" class="btn btn-secondary"><i class="fp-invoice"></i> Preview Invoice
                        </button>
                        <button v-if="deleted_at == null" type="submit" id="editInvoiceBtn" v-on:click="generateInvoicePdf()" class="btn btn-secondary"><i class="fp-download"></i> Download PDF
                        </button>
                        <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'ListInvoice'}"> <i class="fp-back"></i> Back</router-link> -->
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="backInvoiceList" ><i class="fp-back"> </i>    Back </button>
                        </template>
                    </div>
                </div>
                <div class="container-fluid">
                    <div id="workorder-detail work-order-view-top" class="admin-page-content ft-invoice-view">
                        <template v-if="!isCrmSection">
                        <section class="internal-container border-top-table-fl">
                            <template v-if="invoiceItemsArr.length == 0 || invoiceItemsArr == undefined">
                                <div class="lineitem-main-section">
                                    <h5>No Line Item Added</h5>
                                </div>
                            </template>
                            <template v-else>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="invoiceItemsArr != undefined && invoiceItemsArr.length > 0">
                                        <thead>
                                        <tr class="table-primary">
                                            <th>Unit#</th>
                                            <th>Charge Description</th>
                                            <th>Location</th>
                                            <th>Ref#</th>
                                            <th>PO#</th>
                                            <th>Date#</th>
                                            <th class="text-right">Qty</th>
                                            <th class="text-right">Price</th>
                                            <th class="text-right">Taxes</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-for="(invItems , itemKey) in invoiceItemsArr">
                                            <tr :key="'item1'+itemKey">
                                                <td>{{invItems.unit_no}}</td>
                                                <td>{{invItems.description}}</td>
                                                <td> {{invItems.location}} </td>
                                                <td> {{invItems.referance_no}} </td>
                                                <td> {{invItems.po_number}} </td>
                                                <td> {{invItems.ticket_date}} </td>
                                                <td class="text-right"> {{invItems.inv_line_qty}} </td>
                                                <td class="text-right"> {{invItems.unit_price}} </td>
                                                <td class="text-right"> {{invItems.tax_amount}} </td>
                                                <td class="text-right"> {{invItems.total}} </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                        </section>
                        <!-- Fuel Tax Exemption Message on basis of Customer Credit Information -->
                        <section class="internal-container border-top-table-fl" v-if="tax_exempted != ''">
                            <h6 class="color-red">NOTE : {{tax_exempted}}</h6>
                        </section>
                        <section class="internal-container border-top-table-fl" v-if="paymentArr != undefined && paymentArr.length > 0">
                        <div class="journal-title">
                            <h5> Payment Detail </h5>
                        </div>
                        <template>
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="paymentArr != undefined && paymentArr.length > 0">
                                    <thead>
                                        <tr class="table-primary">
                                            <th># Document</th>
                                            <th class="text-right">Amount</th>
                                            <th>Date</th>
                                            <th>Posted By</th>
                                            <th>Processed By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(pay , payKey) in paymentArr">
                                            <tr :key="'payment'+payKey">
                                                <td v-fp-html="pay.payment_no"></td>
                                                <td class="text-right">{{pay.amount}}</td>
                                                <td>{{pay.date}}</td>
                                                <td>{{pay.posted_by}}</td>
                                                <td>{{pay.payment_by}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </section>
                    <div class="order-summary mt-4"> <!--Description section-->
                        <div class="row">
                            <div class="col-md-6 offset-md-6">
                                <div class="bg-white radius-5 p-3">
                                    <label class="font-bold"> SUMMARY </label>
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <tr class="table-secondary">
                                            <td> Total Before Tax: </td>
                                            <td class="text-right"> {{total_before_tax}} </td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Additional Tax: </td>
                                            <td class="text-right"> {{aft_tax}} </td>
                                        </tr>
                                         <tr class="table-secondary">
                                            <td> Diesel Tax: </td>
                                            <td class="text-right"> {{diesel_tax}} </td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Sales Tax: </td>
                                            <td class="text-right"> {{sales_tax_total}} </td>
                                        </tr>
                                        <tr>
                                            <td> Total Taxes: </td>
                                            <td class="text-right discount-order-box">{{total_taxes}}</td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Total Due: </td>
                                            <td class="order-total text-right"> {{total_due}} </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> <!--Description section-->
                        <!-- Journals -->
                    <section class="internal-container border-top-table-fl mt-4 loader-position">
                        <div :class="`loader-div${loaderClass}`" v-show="glLoading"></div>
                        <div class="journal-title">
                            <h5> General Ledger <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i>   </h5>
                        </div>
                        <div :id="'demo'" class="accordian-body collapse show">
                            
                            <div class="table-responsive-sm">
                            <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1" >
                                <thead>
                                    <tr class="table-primary">
                                        <th>Account</th>
                                        <th class="text-right">Debit</th>
                                        <th class="text-right">Credit</th>
                                        <th class="text-right">Amount</th>
                                    </tr>
                                </thead>
                                <tbody v-if="glArr != undefined && glArr.length > 0">
                                    <template v-for="(journalItem , journalKey) in glArr">
                                            <tr :key="'journal'+journalKey">
                                                <template v-if="journalItem.account_description == 'Total'">
                                                    <td class="text-right">{{journalItem.account_description}}</td>
                                                </template>
                                                <template v-else>
                                                    <td>{{journalItem.account_description}}</td>
                                                </template>
                                                <td class="text-right">{{journalItem.debit}}</td>
                                                <td class="text-right">{{journalItem.credit}}</td>
                                                <td class="text-right">{{journalItem.journal_amount}}</td>
                                            </tr>
                                    </template>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="4"><h5>No GL Found</h5></td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </section>
                    
                    </template>
                    <template v-else>
                        <!-- Invoice Crm -->
                        <div id="invoice-crm-list" class="admin-page-content invoice-view list-view">
                            <template v-if="crmAdd">
                                <crm-create :fromModule="invoiceObj"></crm-create>
                            </template>
                            <template v-else>
                                <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                                <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                    <div class="bg-white data-table p-0">
                                        <invoice-crm-list v-if="enableInvoiceCrm" :moduleVal="'invoice'" :moduleId="invoiceId"></invoice-crm-list>
                                    </div>
                                </section>
                            </template>
                        </div>
                    </template>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';

    
    import {commonMixins} from '../../mixins/commonMixins';
    import ActivityLogListView from '@/components/ActivityLogList.vue';
    
    Vue.component("invoice-activity-log-list", ActivityLogListView);
    import CrmCreate from "@/components/CrmCreate.vue";
    Vue.component("crm-create", CrmCreate);
    export default {
        name: "FuelTicketInvoiceView",
        components: {
            invoiceCrmList: () => import('@/components/CrmList.vue')
        },
        mixins:[commonMixins],
        data: () => ({
            invoiceArr:[],
            invoiceItemsArr:[],
            permissions:[],
            cantAccessPage:"",
            loading:false,
            glLoading:false,
            invoiceId : 0,
            invoice_number:'',
            deleted_at:'',
            invoice_date:'',
            company:'',
            user_number:'',
            customer:'',
            total_before_tax:'',
            total_taxes:'',
            total_due:'',
            activityLogsTabValue: "invoiceloadList",
            activetab: 1,
            glArr:[],
            tax_exempted:"",
            isCrmSection:false,
            enableInvoiceCrm:false,
            canAddCrm:false,
            crmAdd:false,
            invoiceObj:{},
            crmBtnTitle:"CRM",
            fromUrl:"",
            from:"",
            paymentArr:[],
            sales_tax_total:0,
            drop_tax_total:0,
            status:"",
            dueDate:"",
            invType:"",
            term:"",
            created_at:'',
            diesel_tax:0,
            aft_tax:0,
            open_amount:'',
            total_amount:''
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'view_invoice') {
                        self.cantAccessPage = true;
                    }
                    if (permissions.name == 'add_crm') {
                        self.canAddCrm = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },
        mounted: function() {
            var self = this;
            if(this.$route.query.fromUrl != undefined && this.$route.query.fromUrl != ""){
              self.fromUrl = atob(this.$route.query.fromUrl);
            }
            if(this.$route.query.from == "customer"){
              self.from = this.$route.query.from;
            }
            self.invoiceId = this.$route.params.id.toString();
            //set value in invoice object for crm
            self.invoiceObj.module = "invoice";
            self.invoiceObj.invoice_id = this.$route.params.id;
            self.invoiceObj.flag = "add";
            self.invoiceObj.crm_id = "";
            self.getPermissions();
            self.loadInvoiceData();
        },
        metaInfo() {
            return {
                title: (this.invoice_number != "") ? this.invoice_number + " | Customer Invoice View | " +process.env.COPYRIGHT_NAME:"Customer Invoice View | " +process.env.COPYRIGHT_NAME
            }
        },
        methods: {
            loadInvoiceData() {
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/invoice-fuel-ticket/view",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data:{invoice_id:self.invoiceId},
                    dataType: "json",
                    success: function(data) {
                        self.loading = false;
//                        console.log(data.content);
                        if (data.status == "success") {
                            var storeObject={visited_page: {
                                    path : "fuel-ticket-invoice |" +data.content.invoice_number,
                                    data : window.location.pathname,
                                    }};
                             self.getRecentlyPagesMethod(storeObject);

//                                 self.invoice_number = data.content.invoice_number;
                            self.invoiceObj.customer_id = data.content.customer_id;
                            self.invoiceArr = data.content;
                            self.invoice_number = data.content.invoice_number;
                            self.deleted_at = data.content.deleted_at;
                            self.invoice_date = data.content.invoice_date;
                            self.company = data.content.company;
                            self.customer = data.content.customer;
                            self.total_before_tax = data.content.sub_total;
                            self.total_taxes = data.content.tax_amount;
                            self.total_due = data.content.total;
                            self.invoice_origin = data.content.origin;
                            self.sales_tax_total = self.amountFormat(data.content.sales_tax_total);
                            self.aft_tax = self.amountFormat(data.content.aft_tax);
                            self.diesel_tax = self.amountFormat(data.content.diesel_tax);
                            self.drop_tax_total = data.content.drop_tax_total;
                            self.invType = data.content.invoice_type;
                            self.dueDate = data.content.due_date;
                            self.status = data.content.status;
                            self.term = data.content.term_name;
                            self.created_at = data.content.created_at;
                            self.open_amount = data.content.open_amount;
                            self.total_amount = data.content.total;

                            if (data.content.items != undefined) {
                                self.invoiceItemsArr = data.content.items;
                            }else{
                                self.invoiceItemsArr = [];
                            }
                            // if (data.content.gl != undefined) {
                            //     self.glArr = data.content.gl;
                            // }else{
                            //     self.glArr = [];
                            // }
                            if (data.content.tax_exempt != undefined && data.content.tax_exempt != null) {
                                self.tax_exempted = data.content.tax_exempt;
                            }
                            self.paymentArr = data.content.payment;
                            self.getGLEntry(data.content.invoice_number);

                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'rental-contract-invoice-view');
                    }
                });
            },
            getGLEntry(invNo) {

                var self = this;
                self.glLoading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/module/gl",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{'id':self.invoiceId,'doc_no':invNo,'name':'customer invoice'},
                    success: function (data) {
                        self.glLoading = false;
                        if (data.status == "success") {
                            self.glArr = data.content;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.glLoading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'workorder-invoice-view');
                    }
                });
            },
            activityLogs(){

                var self = this;
                self.$root.$emit('activity_log_opted','fuel ticket',self.invoiceId);
                self.activityLogsTabValue = "invoiceloadList";     // flag value set to loadList so that filters in list work properly.
                self.activetab = 2;
            },
            generateInvoicePdf(){

                var self = this;

                self.loading = true ;
                $.ajax({
                    url: process.env.ROOT_API + "/invoice/pdf",
                    type: "POST",
                    data: {
                        invoice_id:self.invoiceId,
                        invoice_origin:"system",
                        invoice_type:"FB",
                    },
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false ;
                        if (data.status == 'success'){
                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = data.content;
                            link.download = '';
                            link.target = "_blank";
                            link.click();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'rental-contract-invoice-pdf');
                    }
                });

            },
            previewInvoice() {
                var self = this;
                self.$router.push("/invoice/fuel-ticket/preview/" + self.invoiceId);
            },
            crmSection() {
                var self = this;
                if (!self.isCrmSection) {
                    self.isCrmSection = true;
                    self.enableInvoiceCrm = true;
                    self.crmBtnTitle = "Detail";
                }else{
                    self.isCrmSection = false;
                    self.enableInvoiceCrm = false;
                    self.crmAdd = false;
                    self.crmBtnTitle = "CRM";
                }
            },
            addCrm() {
                var self = this;
                self.crmAdd = true;
                self.invoiceObj.crm_id = "";
                self.invoiceObj.flag = "add";
            },
            cancelCrmFromView() {
                var self = this;
                self.crmAdd = false;
            },
            editCrmFromView(crmId){
                var self = this;
                self.crmAdd = true;
                self.invoiceObj.crm_id = crmId;
                self.invoiceObj.flag = "update";
            },
            backInvoiceList() {
            var self = this;
             var url = '/invoice/list';

            if ( self.fromUrl != "" ) {
              if(self.from == 'customer'){
                var  selectTab = '?viewTab=invoice';
                url = self.fromUrl+selectTab;
              }else{
                url = self.fromUrl;
              }

            }
            if(this.$route.query.from != undefined && this.$route.query.from == 'gl'){
              self.$router.push('/report/general-ledger');
            }else {
              self.redirectPageUrl(url);
            }

        },
        }
    }
</script>
<style scoped>
    .text-right{
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/invoice/FuelTicketInvoice.vue